<template>
  <div class="spwwMainContPage">
    <SearchAndResults :options="options" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SearchAndResults from './SearchAndResults/index.vue'
export default {
  components: {
    SearchAndResults
  },
  data() {
    return {
      options: {}
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  created() {
    let imgCnOrEn = this.language === 'spanish' ? 'spanish' : 'en'
    this.options = {
      contactUs: this.$t('spww.contactUs'),
      btnBgi: require('@/assets/images/spww/track_' + imgCnOrEn + '_blue.png'),
      btnBgiHover: require('@/assets/images/spww/track_' + imgCnOrEn + '_blue.png')
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
.spwwMainContPage {
  flex: 1;
  padding-top: 192px;
  width: 1000px;
  margin: 0 auto;
}
</style>
